<template>
  <div class="widget__content-container insurance-semler__column">
    <div
      class="insurance-semler__inner-column insurance-semler__inner-column--left"
      :class="{
        'insurance-semler__inner-column--open': isOpen,
      }"
    >
      <p class="insurance-semler__subtitle">
        Nedenfor kan du beregne din pris og få et uforpligtigende tilbud.
      </p>
      <h4 class="insurance-semler__dropdown-title">
        Vælg din alder for at se din pris
      </h4>
      <div class="insurance-semler__dropdown-container">
        <button
          class="insurance-semler__select-button"
          type="menu"
          @click="toggleDropdown()"
        >
          <div>
            <p>
              <span v-html="chooseAgeTitle"></span>
              <span
                class="insurance-semler__selection-text"
                v-if="selectionText != ''"
                >(<span v-html="selectionText"></span>)</span
              >
            </p>
          </div>
          <Arrow :direction="isOpen ? 'down' : 'right'" />
        </button>
        <div
          class="insurance-semler__dropdown-list"
          :class="{ hidden: !isOpen }"
        >
          <List
            :type="type"
            :search-type="searchType"
            :items="items"
            :event-bus="proxyBus"
          ></List>
        </div>
      </div>
      <div class="insurance-semler__logo-container">
        <span>i samarbejde med</span>
        <img
          :src="makeImageUrl"
          :alt="makeName"
          class="insurance-semler__make-logo"
        />
        <span>&amp;</span>
        <img
          src="@/assets/icons/semler.svg"
          alt="Semler"
          class="insurance-semler__semler-logo"
        />
      </div>
    </div>
    <div
      class="insurance-semler__inner-column insurance-semler__inner-column--right"
    >
      <div>
        <p class="insurance-semler__price">
          Forsikringspræmie
          {{ thousandSeparator(insurancePriceCalculated) }} {{ postfix }}
        </p>

        <dl class="insurance-semler__details-table table-flex">
          <dt class="table-flex__type">Selvrisiko</dt>
          <dd class="table-flex__definition">
            {{ thousandSeparator(coinsuranceCalculated) }} {{ postfix }}
          </dd>
          <dt class="table-flex__type">Bilens pris</dt>
          <dd class="table-flex__definition">
            {{ thousandSeparator(carPrice) }} {{ postfix }}
          </dd>
        </dl>
        <p class="insurance-semler__small-caption-text">
          Præmien er baseret på bilens pris samt din alder.
        </p>
      </div>

      <button
        class="button button--highlight insurance-semler__open-contact-form-button"
        :disabled="inProgress"
        @click.prevent="openContactForm()"
      >
        Udfyld ansøgning
        <ButtonSpinner v-if="inProgress" />
      </button>

      <InsuranceSemlerContactForm
        :adId="adId"
        :recaptchaSitekey="recaptchaSitekey"
        :userEmailProp="userEmailProp"
        :userNameProp="userNameProp"
        :userPhoneProp="userPhoneProp"
        :insurancePrice="insurancePriceCalculated"
        :coinsurancePrice="coinsuranceCalculated"
        :adPrice="adPrice"
        :insuranceCompanyName="insuranceCompanyName"
        :selectedAge="selectionText"
        ref="insuranceSemlerContactForm"
      ></InsuranceSemlerContactForm>
    </div>
  </div>
</template>

<script>
import { app } from '@/main'
import mitt from 'mitt'
import List from '@search/List/List.vue'
import Arrow from '@shared/Arrow/Arrow.vue'
import ButtonSpinner from '@components/Shared/ButtonSpinner/ButtonSpinner.vue'
import InsuranceSemlerContactForm from './InsuranceSemlerContactForm.vue'
import {
  LogWidgetShownInsuranceSemler,
  LogWidgetInitiateApplicationInsuranceSemler,
} from '@/events'

import { thousandSeparator } from '@/functions'

export default {
  name: 'InsuranceSemler',
  components: {
    List,
    Arrow,
    ButtonSpinner,
    InsuranceSemlerContactForm,
  },
  props: {
    adId: { default: null, type: Number },
    userNameProp: { default: '', type: String },
    userEmailProp: { default: '', type: String },
    userPhoneProp: { default: '', type: String },
    adPrice: { default: null, type: Number },
    recaptchaSitekey: { default: '', type: String },
    makeImageUrl: { default: '', type: String },
    makeName: { default: '', type: String },
    insuranceCompanyName: { default: '', type: String },
  },
  data: function () {
    return {
      carPrice: 0,
      chooseAgeTitle: 'Din alder',
      selectedAge: 0,
      selectionText: '',
      insurancePriceCalculated: 0,
      coinsuranceCalculated: 0,
      items: [
        { name: 'Under 25 år', value: 1 },
        { name: 'Mellem 25 og 29 år', value: 2 },
        { name: 'Over 30 år', value: 3, selected: true },
      ],
      singleSelect: true,
      type: 'radio',
      searchType: 'radio-group1',
      proxyBus: mitt(),
      isOpen: false,
      postfix: 'kr.',
      inProgress: false,
    }
  },
  methods: {
    onChange(options) {
      this.selectedAge = options.value
      this.items.forEach(item => {
        item.selected = item.value == options.value
      })
      this.selectionText = options.summaryOptions[0].name

      this.calculateInsurancePrice()
      this.calculateCoinsurancePrice()

      this.isOpen = false
    },
    calculateInsurancePrice() {
      if (this.carPrice < 125000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 595
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 395
        }
      } else if (this.carPrice >= 125000 && this.carPrice < 225000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 645
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 465
        }
      } else if (this.carPrice >= 225000 && this.carPrice < 275000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 695
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 495
        }
      } else if (this.carPrice >= 275000 && this.carPrice < 375000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 795
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 560
        }
      } else if (this.carPrice >= 375000 && this.carPrice < 475000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 895
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 610
        }
      } else if (this.carPrice >= 475000 && this.carPrice < 625000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 1050
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 740
        }
      } else if (this.carPrice >= 625000 && this.carPrice < 800000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 1170
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 805
        }
      } else if (this.carPrice >= 800000 && this.carPrice < 900000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 1305
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 880
        }
      } else if (this.carPrice >= 900000 && this.carPrice < 1000000) {
        if (this.selectedAge == 1) {
          this.insurancePriceCalculated = 1465
        } else if (this.selectedAge >= 2) {
          this.insurancePriceCalculated = 965
        }
      } else if (this.carPrice > 1000000) {
        this.insurancePriceCalculated = null
      }
    },
    calculateCoinsurancePrice() {
      if (this.selectedAge == 1) {
        this.coinsuranceCalculated = 12000
      } else if (this.selectedAge == 2) {
        this.coinsuranceCalculated = 7000
      } else if (this.selectedAge == 3) {
        this.coinsuranceCalculated = 5000
      }

      if (this.carPrice > 1000000) {
        this.coinsuranceCalculated = null
      }
    },
    toggleDropdown() {
      if (this.isOpen) {
        this.isOpen = false
      } else {
        this.isOpen = true
      }
    },
    openContactForm() {
      LogWidgetInitiateApplicationInsuranceSemler()
      this.$refs.insuranceSemlerContactForm.openForm()
    },
    thousandSeparator(value) {
      return thousandSeparator(value)
    },
  },
  created() {
    LogWidgetShownInsuranceSemler()

    this.carPrice = this.adPrice
    this.proxyBus.on('search-request-callback', this.onChange)

    app.mitt.emit('insurance-module-loaded')
  },
}
</script>

<style lang="scss">
@import 'InsuranceSemler.scss';
</style>
